import { render, staticRenderFns } from "./CelebrityCard.vue?vue&type=template&id=2b765425&"
import script from "./CelebrityCard.vue?vue&type=script&lang=js&"
export * from "./CelebrityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports